<div class="row mrgn-bttm-lg">
    <div class="col-md-12">
        <div>
        <h3 class="text-center" [innerHtml]="termsAndConditions.terms.title_line1"></h3>
        <h3 class="text-center" [innerHtml]="termsAndConditions.terms.title_line2"></h3>
        <h4>
            <strong>{{ termsAndConditions.terms.part1 }}</strong>
        </h4>
        <p [innerHtml]="termsAndConditions.terms.part1_description1"></p>
        <h4>
            <strong>{{ termsAndConditions.terms.part2 }}</strong>
        </h4>
        <ol type="a">
            <li [innerHtml]="termsAndConditions.terms.part2_item_a"></li>
            <li [innerHtml]="termsAndConditions.terms.part2_item_b"></li>
            <li [innerHtml]="termsAndConditions.terms.part2_item_c"></li>
        </ol>
        <h4>
            <strong>{{ termsAndConditions.terms.part3 }}</strong>
        </h4>
        <ol type="I">
            <li [innerHtml]="termsAndConditions.terms.part3_item_I"></li>
            <li [innerHtml]="termsAndConditions.terms.part3_item_II"></li>
        </ol>
        <p [innerHtml]="termsAndConditions.terms.part3_description1"></p>
        <h4>
            <strong>{{ termsAndConditions.terms.part4 }}</strong>
        </h4>
        <ol type="I">
            <h5>
                <u>{{ termsAndConditions.terms.part4_item1_title }}</u>
            </h5>
            <p [innerHtml]="termsAndConditions.terms.part4_item1_description"></p>
            <li [innerHtml]="termsAndConditions.terms.part4_item1_part_I"></li>
            <ol type="a">
                <li [innerHtml]="termsAndConditions.terms.part4_item1_part_I_item_a"></li>
                <li [innerHtml]="termsAndConditions.terms.part4_item1_part_I_item_b"></li>
            </ol>
            
            <li [innerHtml]="termsAndConditions.terms.part4_item1_part_II"></li>
            <ol type="a">
                <li [innerHtml]="termsAndConditions.terms.part4_item1_part_II_item_a"></li>
                <li [innerHtml]="termsAndConditions.terms.part4_item1_part_II_item_b"></li>
                <li [innerHtml]="termsAndConditions.terms.part4_item1_part_II_item_c"></li>
            </ol>            
            
            <li [innerHtml]="termsAndConditions.terms.part4_item1_part_III"></li>

            <h5>
                <u>{{ termsAndConditions.terms.part4_item1_part_IV_title }}</u>
            </h5>
            <li [innerHtml]="termsAndConditions.terms.part4_item1_part_IV"></li>
            <ol type="a">
                <li [innerHtml]="termsAndConditions.terms.part4_item1_part_IV_item_a"></li>
                <li [innerHtml]="termsAndConditions.terms.part4_item1_part_IV_item_b"></li>
            </ol>

            <h5>
                <u>{{ termsAndConditions.terms.part4_item1_part_V_title }}</u>
            </h5>
            <li [innerHtml]="termsAndConditions.terms.part4_item1_part_V"></li>
            <ol type="a">
                <li [innerHtml]="termsAndConditions.terms.part4_item1_part_V_item_a"></li>
                <ol type="i">
                    <li [innerHtml]="termsAndConditions.terms.part4_item1_part_V_item_a_item_i"></li>
                    <li [innerHtml]="termsAndConditions.terms.part4_item1_part_V_item_a_item_ii"></li>
                    <li [innerHtml]="termsAndConditions.terms.part4_item1_part_V_item_a_item_iii"></li>
                    <li [innerHtml]="termsAndConditions.terms.part4_item1_part_V_item_a_item_iv"></li>
                    <li [innerHtml]="termsAndConditions.terms.part4_item1_part_V_item_a_item_v"></li>
                </ol>
                <li [innerHtml]="termsAndConditions.terms.part4_item1_part_V_item_b"></li>
                <li [innerHtml]="termsAndConditions.terms.part4_item1_part_V_item_c"></li>
            </ol>

            <h5>
                <u>{{ termsAndConditions.terms.part4_item1_part_VI_title }}</u>
            </h5>
            <li [innerHtml]="termsAndConditions.terms.part4_item1_part_VI"></li>
        </ol>
        </div>
    </div>
</div>